import angular from 'angular';
import confirmationOrderComponent from './confirmation-order.component';
import ConfirmationOrderService from './confirmation-order.service';
import ModalExperienceController from './modal-experience/modal-experience.controller';

let confirmationOrderModule = angular.module('app.confirmationOrder',[])
   .controller('ModalExperienceController', ModalExperienceController)
  .component('confirmationOrder', confirmationOrderComponent)
  .service('ConfirmationOrderService', ConfirmationOrderService);

export default confirmationOrderModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/confirmation-order/confirmation-order.js
 **/